export const uiTranslations = {
  de: {
    nav: {
      home: "Start",
      about: "Über mich",
      experience: "Erfahrung",
      skills: "Kompetenzen",
      documents: "Dokumente",
      education: "Bildung",
      workstyle: "Arbeitsweise",
      personal: "Persönliches",
      contact: "Kontakt"
    },
    hero: {
      tag: "Digitale Bewerbungsmappe",
      ctaContact: "Kontakt aufnehmen",
      ctaDocs: "Unterlagen ansehen",
      stats: [
        { value: "10+", label: "Jahre Erfahrung" },
        { value: "1,5 Mio.", label: "Nutzer (Joint Login)" },
        { value: "22 %", label: "Conversion-Steigerung" },
        { value: "31 auf 48", label: "NPS-Verbesserung" }
      ]
    },
    sections: {
      about: { title: "Über mich", label: "PROFIL" },
      experience: { title: "Berufserfahrung", label: "WERDEGANG" },
      skills: { title: "Kompetenzen", label: "KOMPETENZBEREICH" },
      documents: { title: "Dokumente & Belege", label: "BELEGE" },
      education: { title: "Bildungsweg", label: "AUSBILDUNG" },
      workstyle: { title: "Arbeitsweise", label: "PHILOSOPHIE" },
      personal: { title: "Neben der Arbeit", label: "PERSÖNLICHES" },
      contact: { title: "Kontakt", label: "VERBINDUNG" }
    },
    docs: {
      application: "Bewerbung",
      references: "Aktuelle Arbeitszeugnisse",
      certificates: "Zertifikate"
    },
    experience: {
      responsibilities: "Verantwortung & Aufgaben",
      results: "Ergebnisse & Erfolge",
      present: "heute",
      exitReason: "Grund des Ausscheidens"
    },
    skills: {
      languages: "Sprachen",
      misc: "Sonstiges"
    },
    contact: {
      emailLabel: "E-Mail schreiben",
      phoneLabel: "Anrufen",
      mapLabel: "In Google Maps öffnen"
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Me",
      experience: "Experience",
      skills: "Skills",
      documents: "Documents",
      education: "Education",
      workstyle: "Work Style",
      personal: "Personal",
      contact: "Contact"
    },
    hero: {
      tag: "Digital Application Portfolio",
      ctaContact: "Get in touch",
      ctaDocs: "View Documents",
      stats: [
        { value: "10+", label: "Years of experience" },
        { value: "1.5M", label: "Users (Joint Login)" },
        { value: "22%", label: "Conversion uplift" },
        { value: "31 to 48", label: "NPS improvement" }
      ]
    },
    sections: {
      about: { title: "About Me", label: "PROFILE" },
      experience: { title: "Professional Experience", label: "CAREER" },
      skills: { title: "Skills & Expertise", label: "COMPETENCIES" },
      documents: { title: "Documents & Credentials", label: "EVIDENCE" },
      education: { title: "Education", label: "EDUCATION" },
      workstyle: { title: "How I Work", label: "PHILOSOPHY" },
      personal: { title: "Outside of Work", label: "PERSONAL" },
      contact: { title: "Contact", label: "CONNECTION" }
    },
    docs: {
      application: "Application",
      references: "Current Reference Letters",
      certificates: "Certificates"
    },
    experience: {
      responsibilities: "Responsibilities & Tasks",
      results: "Results & Achievements",
      present: "present",
      exitReason: "Reason for leaving"
    },
    skills: {
      languages: "Languages",
      misc: "Other"
    },
    contact: {
      emailLabel: "Send email",
      phoneLabel: "Call",
      mapLabel: "Open in Google Maps"
    }
  }
};